import React, { Component } from 'react';
import PropTypes from 'prop-types';

import lodashGet from 'lodash/get';

import { USER_ROLE_ADMIN, USER_ROLE_AGENT } from 'common/userRoles';

import { SCREEN_ID_AGENT_MAP } from 'client/constants/screenIds';

import branch from 'client/core/branch';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import allowedRoles from 'client/helpers/allowedRoles';

import SrSwipeableListingCard from 'client/components/SrSwipeableListingCard';
import SrAgentDashboardTabBar from 'client/components/SrAgentDashboardTabBar';
import SrAgentMapView from 'client/components/SrAgentMapView';
import NavbarButton from 'client/components/NavbarButton';
import Navbar from 'client/components/Navbar';

import AgentActions from 'client/actions/Agent';

@withTransitionHook
@allowedRoles({
  roles: [USER_ROLE_AGENT, USER_ROLE_ADMIN],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withScreenId(SCREEN_ID_AGENT_MAP)
@withScrollToTop
@branch({
  currentUser: ['currentUser'],
  viewingTour: ['agentMapView', 'viewingTour'],
  viewingRenter: ['agentMapView', 'viewingRenter'],
  viewingListing: ['agentMapView', 'viewingListing'],
  listingPhotoResolution: ['listingPhotoResolution'],
})
class AgentMapPage extends Component {
  static fetchData(match, inject) {
    const agentUserId = match.params.agentUserId
      ? parseInt(match.params.agentUserId, 10)
      : inject.state.get(['currentUser', 'id']);

    return AgentActions.getAgentTours(inject, { agentUserId });
  }

  static getPageMetadata = () => ({
    pageTitle: 'Sunroom Scheduled Tours',
    section: 'Admin',
  });

  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    viewingTour: PropTypes.object,
    viewingRenter: PropTypes.object,
    viewingListing: PropTypes.object,
    listingPhotoResolution: PropTypes.number.isRequired,
  };

  constructor() {
    super();

    this.state = {
      isMobile: false,
    };
  }

  componentDidMount() {
    this._setBrowserWidthInState();
  }

  _setBrowserWidthInState = () => {
    const browserWidth =
      global.innerWidth ||
      lodashGet('documentElement.clientWidth', global.document) ||
      lodashGet('body.clientWidth', global.document);

    this.setState({
      isMobile: browserWidth < 700,
    });
  };

  _onSwipe = () => {
    this.props.dispatch(({ state }) => {
      state.set(['agentMapView', 'viewingListing'], null);
    });
  };

  render() {
    const {
      currentUser,
      match,
      history,
      viewingTour,
      viewingRenter,
      viewingListing,
      listingPhotoResolution,
    } = this.props;

    const { isMobile } = this.state;

    const agentUserId = match.params.agentUserId
      ? parseInt(match.params.agentUserId, 10)
      : currentUser.id;

    return (
      <div className="page-agentDashboard">
        <Navbar
          redirectLogoTo="/agent/tours"
          leftButton={
            viewingTour && (
              <NavbarButton onClick={() => history.push(`/agent/${viewingTour.id}/search`)}>
                Filter
              </NavbarButton>
            )
          }
        />
        <SrAgentDashboardTabBar />
        <SrAgentMapView agentUserId={agentUserId} isMobile={isMobile} />
        <SrSwipeableListingCard
          listing={viewingListing}
          currentUser={viewingRenter}
          onSwipe={this._onSwipe}
          agentUser={currentUser}
          agentTourId={viewingTour ? viewingTour.id : null}
          photoResolution={listingPhotoResolution}
        />
      </div>
    );
  }
}

AgentMapPage.displayName = 'AgentMapPage';

export default AgentMapPage;
